import e from"react";import{Container as r}from"../Container/Container.js";var a=function(a){var n=a.children;return e.createElement("div",{className:"c-page-container"},e.createElement(r,{size:"4x-small",hasNoPaddingTop:!0},n))};export{a as PageContainer};
//# sourceMappingURL=PageContainer.js.map
